import { withAuthorization } from "../../authentication/Session/withAuthorization";
import { getAuthorizationGuard } from "../../authentication/authorizations";
import { Role } from "@farmact/model/src/model/Role";
import { lazy } from "react";
import { DefaultPage } from "../../structure/Page/DefaultPage/DefaultPage";

const StripeErrorPageContent = lazy(() => import("./StripeErrorPageContent"));

function StripeErrorPageInternal() {
    return (
        <DefaultPage>
            <StripeErrorPageContent />
        </DefaultPage>
    );
}

export const StripeErrorPage = withAuthorization(getAuthorizationGuard(Role.OWNER))(StripeErrorPageInternal);
